export const SHIFTS = ['A', 'B', 'C'];

export const SKILLS = [
  { key: 'derulare', label: 'Derulare' },
  { key: 'izolareConductor', label: 'Izolare Conductor' },
  { key: 'rope', label: 'Rope' },
  { key: 'interiorMantle', label: 'Interior Mantle' },
  { key: 'armare', label: 'Armare' },
  { key: 'exteriorMantle', label: 'Exterior Mantle' }
];

export const MACHINES = [
  'L75',
  'L70',
  'L120',
  'DTB1250',
  'SKIP2250',
  'ACH300',
  'DHC600',
  'ATH600'
];

export const SHIFT_COLORS = {
  A: 'primary',
  B: 'success',
  C: 'warning'
};
